import React, { useContext } from 'react';
import { Button } from 'baseui/button';

import { ModalContext } from 'commons-ui';
import AddNewPgFormContent from './AddNewPgFormContent';

const AddNewPaymentGateway = () => {
	const { setModalConfig } = useContext(ModalContext);
	const handleAddNewPaymentGateway = async () => {
		setModalConfig({
			isOpen: true,
			header: 'Add New Payment Gateway',
			content: <AddNewPgFormContent />
		});
	};

	return (
		<Button onClick={handleAddNewPaymentGateway} style={{ margin: '10px 100px' }} size='compact'>
			Add New Payment Gateway
		</Button>
	);
};

export default AddNewPaymentGateway;
